import script from "./PushNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./PushNotification.vue?vue&type=script&setup=true&lang=js"

import "./PushNotification.vue?vue&type=style&index=0&id=30b72f7e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b72f7e"]])

export default __exports__